import React from 'react'
import "./About.css"
export default function About() {
  return (
    <div>About</div>
  )
}
